// export const clientWidth = Number(document.documentElement.clientWidth)
// eslint-disable-next-line
let thebox = {}
if (!process.server) {
  thebox = {
    clientWidth: Number(document.documentElement.clientWidth),
    clientHeight: Number(document.documentElement.clientHeight)
  }
}
export default thebox
